import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

/**
 * Registration DTO Schema for creating new user accounts
 */
export const RegisterDtoSchema = z
    .object({
        /** User email address */
        email: z.string().email('Invalid email format').toLowerCase(),

        /** User password - minimum 8 characters */
        password: z.string().min(8, 'Password must be at least 8 characters'),

        /** User display name (optional) */
        name: z.string().min(1).max(100).optional(),
    })
    .strict();

/**
 * Registration DTO for creating new user accounts
 */
export class RegisterDto extends FromSchema(RegisterDtoSchema) {
    email: string;
    password: string;
    name?: string;
}
